import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import From from '../CreateAdmin/components/From/From';

const useStyles = makeStyles(theme => ({
    root: {
        padding: '24px',
    },

}));

export default function CreateAdmin(props) {

    const { className } = props;
    const classes = useStyles();

    return (

        <div className={clsx(classes.root, className)} >
      
            <From/>
        </div>
    )
}
